import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Button, ApiUtil } from '@everfi/reactifi';
import i18n from "lib/utility/i18n";
import MediaChooser from '../../bundles/admin/components/MediaChooser';
import Modal from 'react-bootstrap/Modal';
import { AlertMessage, AlertMessageTypes } from 'reactifi';

export const keyTab = {
  MEDIA: 1,
  UPLOAD: 2
}

export const MediaUrlPicker = props => {
  const { accountId } = props;
  const mediaChooserRef = useRef(null);
  const [mediaModalOpen, setMediaModalOpen] = useState(false);
  const [activeMedia, setActiveMedia] = useState(null);
  const [mediaName, setMediaName] = useState('');
  const [mediaDescription, setMediaDescription] = useState('');
  const [activeTab, setActiveTab] = useState(1);

  const [alertMessage, setAlertMessage] = useState('')
  const [showAlert, setShowAlert] = useState(false)

  const handleFormChange = (e) => {
    if (e.target.name === 'media_name') {
      setMediaName(e.target.value);
    } else if (e.target.name === 'media_description') {
      setMediaDescription(e.target.value);
    }
  };

  const setMedia = async () => {
    const media = {
      name: mediaName,
      description: mediaDescription,
      url: activeMedia.url
    }

    const data = { type: 'next_media', attributes: media };

    if (accountId) {
      media.account_id = accountId;
    }

    if (parseInt(activeTab) === keyTab.UPLOAD) {
      ApiUtil.requestApiData(`/api/data/next_media`, false, 'POST', {
        body: JSON.stringify({ data })
      }, false);
    }
    if (mediaChooserRef.current) {
      mediaChooserRef.current.reloadGalleryWithNewImage();
      mediaChooserRef.current.handleSelectPage(1);
    }

    displayAlert('success', i18n.t('Content was successfully uploaded.'))
    setActiveTab(1);
    setActiveMedia(null)
    setMediaName('')
    setMediaDescription('')
  }

  const hideAlert = () => {
    setAlertMessage('')
    setShowAlert(false)
  }

  const displayAlert = (status, message) => {
    setAlertMessage(message)
    setShowAlert(true)

    setTimeout(() => hideAlert(), 4000);
  }

  const mediaModal = () => {
    return (
      <Modal
        animation={false}
        show={mediaModalOpen}
        className="modal-size-large"
        onHide={() => setMediaModalOpen(false)}
      >
        <Modal.Header closeButton={true}>
          <Modal.Title>{i18n.t('Media Chooser')}</Modal.Title>
        </Modal.Header>

        <AlertMessage
          message={alertMessage}
          messageType={AlertMessageTypes.success}
          visible={showAlert}
          clearMessages={hideAlert}
        />

        <Modal.Body>
          <MediaChooser
            onActiveMediaChange={media => setActiveMedia(media)}
            onHandleFormChange={handleFormChange}
            setActiveTab={setActiveTab}
            activeTab={activeTab}
            ref={mediaChooserRef}
            accountId={accountId}
          />
        </Modal.Body>
        <Modal.Footer className="media-footer">
          {parseInt(activeTab) === keyTab.UPLOAD && <Button
            data-action="set-media"
            style="primary"
            onClick={setMedia}
            disabled={!activeMedia}
          >
            {i18n.t('Upload')}
          </Button>}
          <Button
            data-action="cancel"
            style="secondary"
            onClick={() => setMediaModalOpen(false)}
          >
            {i18n.t('Close')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  return (
    <div>
      <Button
        label={i18n.t('View Media Chooser')}
        icon="image"
        style="link"
        onClick={() => setMediaModalOpen(true)}
      />
      {mediaModal()}
    </div>
  );
};

MediaUrlPicker.propTypes = {
  accountId: PropTypes.string
};

